import 'sk-utils/rem'
 
import Vue from 'vue'
import '@/pages/app/index.js'

const requireComponent = require.context('@/components', true, /[a-z0-9]+.(jsx?|vue)$/i)
requireComponent.keys().forEach(fileName => {
  if (fileName.lastIndexOf('/') === 1) {
    const componentConfig = requireComponent(fileName)
    Vue.component(componentConfig.default.name, componentConfig.default || componentConfig)
  }
})
Vue.component('calculatorController', () => import('@/views/calculatorController/index'))
Vue.component('calculatorOnlineController', () => import('@/views/calculatorOnlineController/index'))
Vue.component('cloudDeskTopOtherSystemController', () => import('@/views/cloudDeskTopOtherSystemController/index'))
Vue.component('deliveryDeployProjectDetailController', () => import('@/views/deliveryDeployProjectDetailController/index'))
Vue.component('pocProjectDetailController', () => import('@/views/pocProjectDetailController/index'))
Vue.component('pocProjectDetailOverviewController', () => import('@/views/pocProjectDetailOverviewController/index'))
Vue.component('showFeiShuDocumentController', () => import('@/views/showFeiShuDocumentController/index'))
Vue.component('toolController', () => import('@/views/toolController/index'))
